import React from "react";
import { App as AntdApp } from "antd";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/loginPage";
import HomePage from "./pages/homePage";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./hooks/useAuth";
import useAxiosInterceptor from "./util/axios";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ResourcePage from "./pages/resourcePage";
import AddResourcePage from "./pages/addResourcePage";
import { HomePageLayout } from "./components/HomePageLayout/HomePageLayout";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queries/queryClient";
import DevicePage from "./pages/devicePage";
import AddDevicePage from "./pages/addDevicePage";
import UserPage from "./pages/userPage";
import AddUserPage from "./pages/addUserPage";
import AcceptInvitePage from "./pages/acceptInvitePage";
import EditResourcePage from "./pages/editResourcePage";
import ServiceAccountsPage from "./pages/serviceAccountsPage";

function App() {
  useAxiosInterceptor();

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <GoogleOAuthProvider
          clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}
        >
          <AntdApp>
            <BrowserRouter>
              <Routes>
                {/* Public Routes */}
                <Route path="/login" element={<LoginPage />} />
                <Route
                  path="/accept-invite/:invite-token"
                  element={<AcceptInvitePage />}
                />

                {/* Protected Routes */}
                <Route element={<ProtectedRoute />}>
                  <Route path="/" element={<Navigate to={"/portal"} />} />
                  <Route path="/portal" element={<HomePageLayout />}>
                    <Route index element={<HomePage />} />
                    <Route path="resources" element={<ResourcePage />} />
                    <Route
                      path="resources/:id"
                      element={<EditResourcePage />}
                    />
                    <Route path="add-resource" element={<AddResourcePage />} />
                    <Route path="devices" element={<DevicePage />} />
                    <Route path="add-device" element={<AddDevicePage />} />
                    <Route path="users" element={<UserPage />} />
                    <Route path="add-user" element={<AddUserPage />} />
                    <Route
                      path="service-accounts"
                      element={<ServiceAccountsPage />}
                    />
                  </Route>
                </Route>

                {/* Fallback Route */}
                <Route path="*" element={<Navigate to="/login" />} />
              </Routes>
            </BrowserRouter>
          </AntdApp>
        </GoogleOAuthProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
